
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface SubscriptionRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SubscriptionRequiredModal: React.FC<SubscriptionRequiredModalProps> = ({ 
  isOpen, 
  onClose 
}) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('subscription.required_title', 'Premium Feature')}</DialogTitle>
          <DialogDescription>
            {t('subscription.required_description', 'This feature requires an active subscription.')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col space-y-4">
          <p>{t('subscription.upgrade_message', 'To access this feature, please upgrade to a premium plan or activate your trial.')}</p>
        </div>
        <DialogFooter className="flex justify-between sm:justify-between">
          <Button variant="outline" onClick={onClose}>
            {t('common.close', 'Close')}
          </Button>
          {<Button onClick={() => {
            onClose();
            navigate('/my-account');
          }}>
            {t('subscription.view_plans', 'View Plans')}
          </Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionRequiredModal;
